const colors = {
  dark: "#1A1A1A",
  white: "#FCFCFC",
  lightGrey: "#F7F7F7",
  darkGrey: "#F2F2F2",
  overlay: "rgba(0, 0, 0, 0.4)",
};

export default colors;
